import React, { useState, useEffect, memo } from "react";
import { SketchPicker } from "react-color";

import leftAlign from "../../../../../assets/images/formatter/left-align.svg";
import rightAlign from "../../../../../assets/images/formatter/right-align.svg";
import justify from "../../../../../assets/images/formatter/justify.svg";

import "./blockformatter.styles.css";

const BlockFormatter = ({ selectedBlock }) => {
  const [visible, setVisible] = useState(false);

  const toggleFormatter = () => {
    console.log(selectedBlock);
    if (selectedBlock === undefined || selectedBlock === null) {
      return;
    }
    setVisible(!visible);
  };

  useEffect(() => {
    if (selectedBlock === null || selectedBlock === undefined) {
      return;
    } else {
      console.log({"selected when click useffect": selectedBlock})
      setVisible(!visible);
    }
  }, [selectedBlock]);

  return (
    <div className="block__formatterWrapper">
      <div className="block__formatter--toggler" onClick={toggleFormatter}>
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="0.5" width="24" height="24" rx="4" fill="white" />
          <path
            d="M17.4765 19.7634L4.82934 6.87635C4.67461 6.71868 4.67699 6.46543 4.83466 6.31069L6.95528 4.22954C7.11295 4.0748 7.36621 4.07718 7.52094 4.23485L20.1681 17.1219C20.3228 17.2795 20.3205 17.5328 20.1628 17.6875L18.0422 19.7687C17.8845 19.9234 17.6312 19.921 17.4765 19.7634Z"
            fill="white"
            stroke="black"
          />
          <path d="M8.16797 5.44727L7.45425 6.1477" stroke="black" />
          <path d="M9.57031 6.87451L8.49974 7.92516" stroke="black" />
          <path d="M10.6211 7.94531L9.90738 8.64575" stroke="black" />
          <path d="M12.0234 9.37256L10.9529 10.4232" stroke="black" />
          <path d="M13.4219 10.7998L12.7082 11.5002" stroke="black" />
          <path d="M14.8242 12.2275L13.7536 13.2782" stroke="black" />
          <path d="M15.875 13.2979L15.1613 13.9983" stroke="black" />
          <path d="M17.2734 14.7256L16.2029 15.7762" stroke="black" />
          <path d="M18.3242 15.7959L17.6105 16.4963" stroke="black" />
          <path
            d="M7.70008 19.4914L5.27266 19.896C4.98282 19.9443 4.74157 19.674 4.82229 19.3915L5.67093 16.4213C5.67734 16.3989 5.68934 16.3784 5.70582 16.362L16.7775 5.29032C17.4901 4.5777 18.6455 4.5777 19.3581 5.29032C20.0707 6.00295 20.0707 7.15834 19.3581 7.87097L7.77756 19.4515C7.75652 19.4726 7.72943 19.4865 7.70008 19.4914Z"
            fill="white"
            stroke="black"
          />
          <path d="M16.5195 6.06445L18.584 8.12897" stroke="black" />
          <path
            d="M5.50391 19.5L8.00391 18.5C7.16675 17.6628 5.73355 18.1221 5.53892 19.2899L5.50391 19.5Z"
            fill="black"
            stroke="black"
          />
        </svg>
        <span>Design</span>
      </div>
      <div
        className={
          visible || selectedBlock !== null
            ? "block__formatter show-formatter"
            : "block__formatter"
        }
      >
        <div className="block__formatter--header">
          <div className="block--type">
            <span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.9765 19.7634L4.32934 6.87635C4.17461 6.71868 4.17699 6.46543 4.33466 6.31069L6.45528 4.22954C6.61295 4.0748 6.86621 4.07718 7.02094 4.23485L19.6681 17.1219C19.8228 17.2795 19.8205 17.5328 19.6628 17.6875L17.5422 19.7687C17.3845 19.9234 17.1312 19.921 16.9765 19.7634Z"
                  fill="white"
                  stroke="black"
                />
                <path d="M7.66797 5.44727L6.95425 6.1477" stroke="black" />
                <path d="M9.07031 6.87451L7.99974 7.92516" stroke="black" />
                <path d="M10.1211 7.94531L9.40738 8.64575" stroke="black" />
                <path d="M11.5234 9.37256L10.4529 10.4232" stroke="black" />
                <path d="M12.9219 10.7998L12.2082 11.5002" stroke="black" />
                <path d="M14.3242 12.2275L13.2536 13.2782" stroke="black" />
                <path d="M15.375 13.2979L14.6613 13.9983" stroke="black" />
                <path d="M16.7734 14.7256L15.7029 15.7762" stroke="black" />
                <path d="M17.8242 15.7959L17.1105 16.4963" stroke="black" />
                <path
                  d="M7.20008 19.4914L4.77266 19.896C4.48282 19.9443 4.24157 19.674 4.32229 19.3915L5.17093 16.4213C5.17734 16.3989 5.18934 16.3784 5.20582 16.362L16.2775 5.29032C16.9901 4.5777 18.1455 4.5777 18.8581 5.29032C19.5707 6.00295 19.5707 7.15834 18.8581 7.87097L7.27756 19.4515C7.25652 19.4726 7.22943 19.4865 7.20008 19.4914Z"
                  fill="white"
                  stroke="black"
                />
                <path d="M16.0195 6.06445L18.084 8.12897" stroke="black" />
                <path
                  d="M5.00391 19.5L7.50391 18.5C6.66675 17.6628 5.23355 18.1221 5.03892 19.2899L5.00391 19.5Z"
                  fill="black"
                  stroke="black"
                />
              </svg>
            </span>
            <h6>
              {selectedBlock?.type === "canvas"
                ? "Background"
                : selectedBlock?.type}
            </h6>
          </div>
          <span className="close">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"
                fill="#C3C3C3"
              />
            </svg>
          </span>
        </div>
        {selectedBlock?.type === "text" && <TextFormatter />}
        {selectedBlock?.type === "shape" && <ShapesFormatter />}
        {selectedBlock?.type === "editor" && <EditorFormatter />}
        {selectedBlock?.type === "image" && <ImageFormatter />}
        {selectedBlock?.type === "canvas" && <CanvasFormatter />}
      </div>
    </div>
  );
};

const ImageFormatter = () => {
  return (
    <div className="">
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Stroke</h6>
        <div className="d-flex align-items-center">
          <input
            type="number"
            value="1"
            name="strokeWidth"
            className="formatter--input"
          />
          <div className="color--box"></div>
          <span>FFFFFF</span>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Radius</h6>
        <div className="d-flex align-items-center">
          <div className="opacity--input">
            <input type="text" name="radius" value="25" />
            <span>%</span>
          </div>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Opacity</h6>
        <div className="d-flex align-items-center">
          <div className="opacity--input">
            <input type="text" name="opacity" value="25" />
            <span>%</span>
          </div>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top btn-upload-height">
        <h6>Upload</h6>
        <button className="upload-btn">
          {" "}
          <span>
            <svg
              width="18"
              height="17"
              viewBox="0 0 18 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.16797 2.33341C6.32698 2.33341 4.83464 3.82579 4.83464 5.66675C4.83464 5.69376 4.83503 5.72198 4.83573 5.75195C4.8448 6.13947 4.58546 6.48208 4.21002 6.57855C3.13111 6.85579 2.33464 7.836 2.33464 9.00008C2.33464 10.3808 3.45395 11.5001 4.83464 11.5001H5.66797C6.12821 11.5001 6.5013 11.8732 6.5013 12.3334C6.5013 12.7937 6.12821 13.1667 5.66797 13.1667H4.83464C2.53348 13.1667 0.667969 11.3013 0.667969 9.00008C0.667969 7.2813 1.70814 5.80713 3.19235 5.16986C3.44177 2.64171 5.57419 0.666748 8.16797 0.666748C10.0209 0.666748 11.637 1.67453 12.5005 3.16945C15.1852 3.25694 17.3346 5.46082 17.3346 8.16675C17.3346 10.9282 15.0961 13.1667 12.3346 13.1667C11.8744 13.1667 11.5013 12.7937 11.5013 12.3334C11.5013 11.8732 11.8744 11.5001 12.3346 11.5001C14.1756 11.5001 15.668 10.0077 15.668 8.16675C15.668 6.32579 14.1756 4.83341 12.3346 4.83341C12.2424 4.83341 12.1513 4.83714 12.0612 4.84443C11.7054 4.87321 11.3708 4.67225 11.2291 4.34467C10.7166 3.15986 9.53788 2.33341 8.16797 2.33341ZM8.41205 6.74416C8.73748 6.41872 9.26512 6.41872 9.59056 6.74416L11.2572 8.41083C11.5827 8.73626 11.5827 9.2639 11.2572 9.58934C10.9318 9.91477 10.4042 9.91477 10.0787 9.58934L9.83464 9.34526V15.6667C9.83464 16.127 9.46154 16.5001 9.0013 16.5001C8.54107 16.5001 8.16797 16.127 8.16797 15.6667V9.34526L7.92389 9.58934C7.59846 9.91477 7.07082 9.91477 6.74538 9.58934C6.41994 9.2639 6.41994 8.73626 6.74538 8.41083L8.41205 6.74416Z"
                fill="#989898"
              />
            </svg>
          </span>
          Upload new image
        </button>
      </div>
    </div>
  );
};

//this can be optimize with .map() and proper object structuring
const TextFormatter = () => {
  return (
    <div className="">
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Text styles</h6>
        <div className="d-flex align-items-center">
          <div className="dropdown">
            <div className="d-flex align-items-center">
              <h6>H1</h6>
              <span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z"
                    fill="black"
                  />
                </svg>
              </span>
            </div>
            <div className="options__dropdown heading-style ">
              <div className="options__dropdown--listItem flex-start">
                <h1>H1</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Font</h6>
        <div className="d-flex align-items-center">
          <div className="dropdown">
            <div className="d-flex align-items-center">
              <h6>Styrene web</h6>
              <span>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z"
                    fill="black"
                  />
                </svg>
              </span>
            </div>
            <div className="options__dropdown heading-style ">
              <div className="options__dropdown--listItem flex-start">
                <h1>H1</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Alignment</h6>
        <div className="d-flex align-items-center">
          <div className="alignment alignment--selected">
            <img src={leftAlign} alt="" />
          </div>
          <div className="alignment">
            <img src={justify} alt="" />
          </div>
          <div className="alignment">
            <img src={rightAlign} alt="" />
          </div>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Fill</h6>
        <div className="d-flex align-items-center">
          <div className="color--box"></div>
          <span>C4C4C4</span>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Stroke</h6>
        <div className="d-flex align-items-center">
          <input
            type="number"
            value="1"
            name="strokeWidth"
            className="formatter--input"
          />
          <div className="color--box"></div>
          <span>FFFFFF</span>
        </div>
      </div>
    </div>
  );
};

const ShapesFormatter = () => {
  return (
    <div className="">
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Fill</h6>
        <div className="d-flex align-items-center">
          <div className="color--box"></div>
          <span>C4C4C4</span>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Stroke</h6>
        <div className="d-flex align-items-center">
          <input
            type="number"
            value="1"
            name="strokeWidth"
            className="formatter--input"
          />
          <div className="color--box"></div>
          <span>FFFFFF</span>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Radius</h6>
        <div className="d-flex align-items-center">
          <div className="opacity--input">
            <input type="text" name="radius" value="25" />
            <span>%</span>
          </div>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Opacity</h6>
        <div className="d-flex align-items-center">
          <div className="opacity--input">
            <input type="text" name="opacity" value="25" />
            <span>%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const EditorFormatter = () => {
  const [picker, setPicker] = useState(false);
  const togglePicker = () => {
    setPicker(!picker);
  };
  return (
    <div className="">
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Fill</h6>
        <div className="d-flex align-items-center canvas-color-picker">
          <div className="color--box" onClick={togglePicker}></div>
          <span>C4C4C4</span>
          {picker && <SketchPicker color="#fff" />}
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Stroke</h6>
        <div className="d-flex align-items-center">
          <input
            type="number"
            value="1"
            name="strokeWidth"
            className="formatter--input"
          />
          <div className="color--box"></div>
          <span>FFFFFF</span>
        </div>
      </div>
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Radius</h6>
        <div className="d-flex align-items-center">
          <div className="opacity--input">
            <input type="text" name="radius" value="25" />
            <span>%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const CanvasFormatter = () => {
  const [picker, setPicker] = useState(false);
  const togglePicker = () => {
    setPicker(!picker);
  };

  return (
    <div className="">
      <div className="options d-flex justify-space-between align-items-center border-top">
        <h6>Fill</h6>
        <div className="canvas-color-picker d-flex align-items-center">
          <div className="color--box" onClick={togglePicker}></div>
          <span>C4C4C4</span>
          {picker && <SketchPicker color="#fff" />}
        </div>
      </div>
      <div className="options background-image">
        <p>Add background image</p>
        <div className="background-image-cover">
          <button>
            <span>
              <svg
                width="18"
                height="17"
                viewBox="0 0 18 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.16797 2.33341C6.32698 2.33341 4.83464 3.82579 4.83464 5.66675C4.83464 5.69376 4.83503 5.72198 4.83573 5.75195C4.8448 6.13947 4.58546 6.48208 4.21002 6.57855C3.13111 6.85579 2.33464 7.836 2.33464 9.00008C2.33464 10.3808 3.45395 11.5001 4.83464 11.5001H5.66797C6.12821 11.5001 6.5013 11.8732 6.5013 12.3334C6.5013 12.7937 6.12821 13.1667 5.66797 13.1667H4.83464C2.53348 13.1667 0.667969 11.3013 0.667969 9.00008C0.667969 7.2813 1.70814 5.80713 3.19235 5.16986C3.44177 2.64171 5.57419 0.666748 8.16797 0.666748C10.0209 0.666748 11.637 1.67453 12.5005 3.16945C15.1852 3.25694 17.3346 5.46082 17.3346 8.16675C17.3346 10.9282 15.0961 13.1667 12.3346 13.1667C11.8744 13.1667 11.5013 12.7937 11.5013 12.3334C11.5013 11.8732 11.8744 11.5001 12.3346 11.5001C14.1756 11.5001 15.668 10.0077 15.668 8.16675C15.668 6.32579 14.1756 4.83341 12.3346 4.83341C12.2424 4.83341 12.1513 4.83714 12.0612 4.84443C11.7054 4.87321 11.3708 4.67225 11.2291 4.34467C10.7166 3.15986 9.53788 2.33341 8.16797 2.33341ZM8.41205 6.74416C8.73748 6.41872 9.26512 6.41872 9.59056 6.74416L11.2572 8.41083C11.5827 8.73626 11.5827 9.2639 11.2572 9.58934C10.9318 9.91477 10.4042 9.91477 10.0787 9.58934L9.83464 9.34526V15.6667C9.83464 16.127 9.46154 16.5001 9.0013 16.5001C8.54107 16.5001 8.16797 16.127 8.16797 15.6667V9.34526L7.92389 9.58934C7.59846 9.91477 7.07082 9.91477 6.74538 9.58934C6.41994 9.2639 6.41994 8.73626 6.74538 8.41083L8.41205 6.74416Z"
                  fill="#fff"
                />
              </svg>
            </span>
            upload cover
          </button>
        </div>
        <span>Delete background image</span>
      </div>
    </div>
  );
};

export default memo(BlockFormatter);
